import axios from 'axios';
import { AxiosInstance } from 'axios';
import AuthService from '@/services/auth.service';

const API: AxiosInstance = axios.create({
  baseURL: process.env.VUE_APP_API_VERSION === 'dev' ? process.env.VUE_APP_FURTHER_API : `${window.location.origin}/`,
  headers: {
    'x-api-key': process.env.VUE_APP_API_KEY,
  },
});

API.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response.status === 401) {
      AuthService.signOutUser(false);
    }
    return Promise.reject(error.response.data);
  },
);

export default API;
